(() => {
  function init(root = document) {
    root.querySelectorAll('[data-nl-menu]').forEach(button => {
      if (button.dataset.nlReady) return;
      button.dataset.nlReady = 'true';
      const menu = document.getElementById(button.getAttribute('aria-controls'));
      if (!menu) return;
      const setOpen = open => {
        button.setAttribute('aria-expanded', String(open));
        button.textContent = open ? 'CLOSE' : 'MENU';
        menu.hidden = !open;
        menu.classList.toggle('nl-open', open);
      };
      button.addEventListener('click', () => setOpen(button.getAttribute('aria-expanded') !== 'true'));
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => setOpen(false)));
      menu.addEventListener('keydown', event => { if (event.key === 'Escape') { setOpen(false); button.focus(); } });
    });
    root.querySelectorAll('[data-nl-gallery]').forEach(gallery => {
      if (gallery.dataset.nlReady) return;
      gallery.dataset.nlReady = 'true';
      const buttons = [...gallery.querySelectorAll('[data-nl-view-button]')];
      function select(button) {
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        gallery.querySelectorAll('[data-nl-view]').forEach(view => view.classList.toggle('is-active', view.dataset.nlView === button.dataset.nlViewButton));
        gallery.querySelector('.nl-gallery-frame').dataset.view = button.dataset.nlViewButton;
        gallery.querySelector('[data-nl-gallery-label]').textContent = button.dataset.nlLabel;
      }
      buttons.forEach(button => button.addEventListener('click', () => select(button)));
      if (buttons.length) select(buttons.find(button => button.getAttribute('aria-pressed') === 'true') || buttons[0]);
    });
    root.querySelectorAll('[data-nl-gifting]').forEach(gifting => {
      if (gifting.dataset.nlReady) return;
      gifting.dataset.nlReady = 'true';
      const tabs = [...gifting.querySelectorAll('[role="tab"]')];
      function select(tab) {
        tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
        });
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); select(tabs[next]); tabs[next].focus(); }
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('[role="tabpanel"]');
    if (panel) document.getElementById(panel.getAttribute('aria-labelledby'))?.click();
  });
})();
